module.exports = __webpack_public_path__ + "static/media/story-read.bcd826c1.png";